import styled from 'styled-components';

export const ContainerPlayer = styled.div`
  width: 100%;
  height: 100%;

  &.vjs-fullscreen .vjs-tech {
    width: 100%;
    height: 100%;
  }

  & .vjs-tech {
    width: 100%;
    height: 100%;
    transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
  }

  &.minimized {
    width: 0;
    height: 0;

    &.vjs-tech {
      width: initial;
      height: 0;
      transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
    }
  }

  &.vjs-fill {
    flex: 1;
  }

  & .vjs-load-progress {
    display: none !important;
  }

  & .vjs-current-time-display, .vjs-time-divider, .vjs-duration-display {
    display: none;
  }
`;
